/** @jsxImportSource theme-ui */

/**
 * The styles for the form container.
 */
export const formContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
}

/**
 * The styles for the field container.
 */
export const fieldContainerStyle = {
  mb: 3,
  pr: 2,
}

/**
 * The styles for the label.
 */
export const labelStyle = {
  fontSize: 1,
  fontWeight: "bold",
}

/**
 * The styles for the select input.
 */
export const selectStyle = {
  width: "100%",
}

/**
 * The styles for the date input.
 */
export const dateInputStyle = {
  width: "100%",
}

/**
 * The styles for the regular input.
 */
export const inputStyle = {
  width: "100%",
}
